import { Button } from 'antd';
import { forwardRef } from "react";
import { UploadOutlined } from '@ant-design/icons';
import Upload from 'antd/lib/upload/Upload';
import type { UploadProps, } from 'antd';
import './UploadFiles.less';
import { ReactNode } from 'react';
import { UploadListType } from 'antd/lib/upload/interface';

interface UploadFilesProps {
    propsUpload?: UploadProps;
    icon?: ReactNode;
    textButton?: string;
    beforeUpload?: (file: any) => void;
    listType?: UploadListType;
    typeButton?: any;
    customRequest?: any;
    disabledButton?: boolean;
    colorButton?: string | number;
    widthButton?: string;
    hiddenUpload?: boolean;
  }

export type Ref = HTMLButtonElement;


/**
 * @component UploadFiles.tsx
 * @description component for upload files
 */

//Se usa la funcion forwardRef, para poder pasar la ref como parametro y asi heredarla del padre al hijo

const UploadFiles = forwardRef<Ref, UploadFilesProps>((props, ref) => {

    const {propsUpload, icon, textButton, 
           beforeUpload, listType, typeButton, colorButton, widthButton,
           hiddenUpload, customRequest, disabledButton } = props;

    return(
        <div>
            <Upload 
            listType={listType ? listType : 'picture'}
            {...propsUpload ? propsUpload : null} 
            beforeUpload={beforeUpload} customRequest={customRequest}>
                    <Button
                        ref={ref ? ref : undefined}
                        disabled={disabledButton ? disabledButton : false}
                        className={disabledButton ? 'disabled-button' : undefined}
                        type={typeButton ? typeButton : 'primary'}
                        style={{display: hiddenUpload ? 'none' : 'block',  
                                background: colorButton ? colorButton : undefined, 
                                border: colorButton ? colorButton : undefined, 
                                width: widthButton ? widthButton : undefined, 
                                height: '50px', borderRadius: '7.03778px',
                               }}
                        icon={icon ? icon : <UploadOutlined />}
                    >
                    {textButton ? textButton : null}
                    </Button>
            </Upload>
        </div>
    )
})

export default UploadFiles